import styled from 'styled-components/macro';

export const BlockContextMenuComponent = styled.div`
  pointer-events: ${(props) => (props.blockPointerEvents ? 'none' : 'initial')};
`;
